<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'invoiceauditForm',
		props: {

		},
		data() {
			return {
				store: {},
				orders: [],
				ordercheckShow: false,
				form: {
					code: '',
					date: '',
					begin: '',
					end: '',
					isbind: false
				}
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			// beforeFormCreate(rule) {
			// 	for (let i = 0; i < rule.length; i++) {
			// 		if (rule[i].field === 'ordercode') {
			// 			rule[i].children[0].props.store = this.store
			// 		}
			// 	}
			// },
			regestEvent() {
				if (this.extra.ordercode) {
					this.fApi.setValue('ordercode', this.extra.ordercode)
					this.$nextTick(()=>{
						
						this.ordercodeButton({el:this.fApi.el('ordercode')}).then(()=>{
							
							if(this.extra.row && this.extra.row.length!=0){
								this.fApi.setValue('collectionaccount', this.extra.row[0].account)
								this.fApi.setValue('invoicetitle', this.extra.row[0].payman)
								this.fApi.setValue('tptid', this.extra.ordercode)
							}
							//this.loading = false
						})
					})
				}
				
				let $son_invoiceoutput_detail = this.fApi.el('$son_invoiceoutput_detail')
				$son_invoiceoutput_detail.gridOptions.showFooter = true
				$son_invoiceoutput_detail.footerField = [{
					type: 'seq',
					field: 'skcode',
					title: '汇总',
				}, {
					type: 'field',
					field: 'orderamount',
					toFixed: 2
				}]
				
				
			},
			beforeSubmit(formData, next) {
				formData.invoicetaxid = formData.invoicetaxid.toUpperCase()
				formData.invoicetaxid = formData.invoicetaxid.replace(new RegExp('O', 'g'), '0')
				//console.log(formData.invoicetaxid)
				this.fApi.setValue('invoicetaxid',formData.invoicetaxid)
				
				if (this.orders && this.orders.length != 0) {
					formData.orders = this.orders
					if(this.extra.row && this.extra.row.length!=0){
						let collectionorderids = []
						this.extra.row.forEach((item)=>{
							collectionorderids.push(item.collectionorderid)
						})
						formData.collectionorderids = collectionorderids.join(',')
					}
				}
				// console.log(formData,next)
				// this.loading = false
				// if(this.isbind){
				// 	this.$message.error('未和ERP关联')
				// 	this.loading = false
				// }else if (formData.amount != formData.paymentamount) {
				// 	this.$message.error('订单金额与付款金额不相等')
				// 	this.loading = false
				// } else if (!window.systemMethods.isemail(formData.addresseeemail)) {
				// 	this.$message.error('邮箱格式错误')
				// 	this.loading = false
				// } else {
				// 	next()
				// }

				if(formData.invoiceattr!=7968 && (formData.urgent==1 || formData.emergent==1)){
					this.$message.error('非普票无法加急')
					this.loading = false
					return
				}
				if (formData.amount != formData.paymentamount) {
					this.$message.error('订单金额与付款金额不相等')
					this.loading = false
				} 
				// else if (!window.systemMethods.isemail(formData.addresseeemail)) {
				// 	this.$message.error('邮箱格式错误')
				// 	this.loading = false
				// } 
				else {
					next()
				}
			},
			ordercodeButton(component) {
				return new Promise((reslove)=>{
					let ordercode = this.fApi.getValue('ordercode')
					
					if (ordercode.startsWith("XD") ){
						component.el.loading = true					
						this.$api.invoiceoutput.listTrades(ordercode, {
							isflow: this.isflow,
							ordercode:ordercode,
						}).then((res) => {
							component.el.loading = false
							let data = res.data
							if (data.length == 0) {
								this.$message.error('暂无订单信息')
							} else {
								let obj = this.getItemValue(data[0], data[0].relation_data)
								this.adddetail(data[0].orderscollection)
								this.fApi.setValue(obj)
								this.getInvoicecompany(obj)
							}
							reslove()
					
						}, (e) => {
							component.el.loading = false
							if (e.type == 'box') {
								let data = e.data.data.data
								if (data.length == 0) {
									this.$message.error('暂无订单信息')
								} else {
									let obj = this.getItemValue(data[0], data[0].relation_data)
									this.fApi.setValue(obj)
								}
							} else {
								this.fApi.resetFields()
								this.fApi.setValue('ordercode', ordercode)
							}
							reslove()
						})
					} else {
						this.$message.error('请填写订单编号以XD开头')
						reslove()
					}
				})
			},
			
			adddetail(relation_data) {
				let $son_invoiceoutput_detail = this.fApi.el('$son_invoiceoutput_detail')
				//console.log($son_invoiceoutput_detail.store)
				$son_invoiceoutput_detail.clear()
				let data = relation_data.map((item)=>{
					return {
						skid:item.skid,
						skcode:item.skcode,
						ordercode:item.ordercode,
						payman:item.payman,
						account:item.account,
						orderamount:item.orderamount,
						shop:item.shop
					}
				})
				data.forEach((item)=>{
					$son_invoiceoutput_detail.store.table.insertAt(item)
				})
				
				
				
			},
			
			afterGet() {
				this.isbind = true
			},
			invoicetaxidButton() {
				let invoicetaxid = this.fApi.getValue('invoicetaxid')
				if (invoicetaxid) {
					this.$api.invoiceoutput.searchinvoicetaxid(invoicetaxid).then((res) => {
						if (!res) {
							this.$message.error('暂无企业信息')
						} else {
							for (let i in res) {
								this.fApi.setValue(i, res[i])
							}
							//this.fApi.setValue(this.getItemValue(res.data[0]))
						}

					})
				} else {
					this.$message.error('请填企业税号')
				}
			},
			invoicetitleButton() {
				let invoicetitle = this.fApi.getValue('invoicetitle')
				if (invoicetitle) {
					this.$api.invoiceoutput.searchinvoicetaxid(0,{invoicetitle:invoicetitle}).then((res) => {
						if (!res) {
							this.$message.error('暂无企业信息')
						} else {
							for (let i in res) {
								this.fApi.setValue(i, res[i])
							}
							//this.fApi.setValue(this.getItemValue(res.data[0]))
						}
			
					})
				} else {
					this.$message.error('请填企业税号')
				}
			},
			getItemValue(data, datas) {

				let obj = {
					customname: '',
					paymenttime: '',
					paymentamount: 0,
					invoicetitle: '',
					invoicetaxid: '',
					invoiceaddress: '',
					invoicephone: '',
					invoicebank: '',
					invoicebankaccount: '',
					addressee: '',
					addresseephone: '',
					addresseeaddress: '',
					amount: 0,
					invoicepreamount: 0,
					mark: '',
					shopname: '',
					ordercreatetime: '',
					tptid: '',
					collectionaccount: '',
				}
				
				obj.customname = data.buyer
				obj.paymenttime = data.pay_time


				obj.addresseeaddress += data.province + data.city + data.district
				obj.addresseecode = data.express_code
				//obj.addresseestatus = this.$store.state.olnStatusMap[data.oln_status]
				if(data.collection){
					obj.collectionaccount = data.collection.account
					obj.invoicetitle = data.collection.payman
					obj.invoicetaxid = data.collection.taxid
				}
				// if (data.invoice) {
				// 	if(data.invoice.invoicetitle){
				// 		obj.invoicetitle = data.invoice.invoicetitle
				// 	}
					
				// 	obj.invoiceemail = data.invoice.invoiceemail
				// 	obj.invoicetaxid = data.invoice.invoicetaxid
				// 	obj.invoiceaddress = data.invoice.invoiceaddress
				// 	obj.invoicephone = data.invoice.invoicephone
				// 	obj.invoicebank = data.invoice.invoicebank
				// 	obj.invoicebankaccount = data.invoice.invoicebankaccount
				// }
				if (data.sensitive_address) {
					if (data.sensitive_address.receiver_name_mask) {
						obj.customname = data.sensitive_address.receiver_name_mask
					}

					obj.addressee = data.sensitive_address.receiver_name_mask
					obj.addresseephone = data.sensitive_address.receiver_phone_mask ? data.sensitive_address
						.receiver_phone_mask : data.sensitive_address.receiver_mobile_mask
					if (data.sensitive_address.receiver_address_mask) {
						obj.addresseeaddress += data.sensitive_address.receiver_address_mask
					}


				}

				//obj.amount = data.real_payment
				obj.mark = ''
				obj.shopname = data.shop_name
				obj.ordercreatetime = data.create_time
				obj.tptid = data.tp_tid
				datas.forEach((item) => {
					this.orders = this.orders.concat(item.orders)
					if (item.oln_status != 4) {
						obj.paymentamount += item.realPayment
						obj.amount += item.realPayment
						obj.invoicepreamount += item.realPayment
					}
				})
				obj.invoicepreamount = data.orderscollectionamount ? data.orderscollectionamount : obj.invoicepreamount
				
				//obj.invoiceattr = 321
				// obj.invoicecompany = 1
				// console.log(obj)
				if (data.post_fee !== 0) {
					this.orders.push(this.getpostfee(data.post_fee))
				}
				this.isbind = true
				return obj
			},
			getpostfee(cost) {
				return {
					bar_code: '100000',
					currency_sum: "0",
					gx_payment: "0",
					gx_price: "0",
					has_refund: "0",
					inventory_status: "已出库",
					is_gift: "0",
					is_package: "",
					item_image_url: "https://img.alicdn.com/bao/uploaded/i3/TB1z1EkQpXXXXaZapXXXXXXXXXX_!!0-item_pic.jpg",
					item_name: "运费（系统自动添加）",
					item_platform_url: "http://item.taobao.com/item.htm?id=554463030991",
					oln_item_id: "100000",
					oln_item_name: "劲功补运费专用/补邮费差价/差几元拍几件/此链接不支持退款！",
					oln_sku_id: "",
					oln_status: "5",
					order_id: "82F1BA15A635322D99E532728D7C6E74",
					order_total_discount: "0",
					payment: cost,
					price: "1",
					num: "1",
					receivable: cost,
					remark: "",
					size: cost,
					sku_code: "100000",
					status: "5",
					sys_goods_uid: "506789F0BF703C6A81955D98A6697F01",
					sys_spec_uid: "F17519D4DAAB3EEEB7E50B51E41F82AF",
					tax_payment: "2.58",
					tax_rate: "1",
					tid_snapshot: "TB3521149345928649242",
					tp_oid: "3521149345928649242",
					tp_tid: "3521149345928649242",
				}
			},
			collectionaccountChange(e){
				this.getInvoicecompany({collectionaccount:e})
			},
			// invoiceattrChange(){
			// 	let data = {}
			// 	data.shopname = this.fApi.getValue('shopname')
			// 	data.invoiceattr = this.fApi.getValue('invoiceattr')
			// 	this.getInvoicecompany(data)
			// },
			// shopnameChange(){
			// 	let data = {}
			// 	data.shopname = this.fApi.getValue('shopname')
			// 	data.invoiceattr = this.fApi.getValue('invoiceattr')
			// 	this.getInvoicecompany(data)
			// },
			getInvoicecompany(data){
				if(data.collectionaccount){
					let target = window.systemData.bankaccount.find((item)=>{
						return item.id == data.collectionaccount
					})
					
					if(target){
						this.fApi.setValue('invoicecompany',target.companyid)
					}
				}
				
				// let type = 'online'
				// let invoiceattr = 7968
				// let invoicecompany = null
				// if(data.shopname.includes('线下')){
				// 	type = 'underline'
				// }
				// if(this.fApi.getValue('invoiceattr')){
				// 	invoiceattr = this.fApi.getValue('invoiceattr')
				// }
				// if(data.collectionaccount == 8808){
				// 	data.invoiceattr = 331
				// 	this.fApi.setValue('invoiceattr',331)
				// }
				
				
				// if(type=='underline' && (invoiceattr == 331 || invoiceattr == 321)){
				// 	invoicecompany  = 14
				// }
				
				// if(invoicecompany){
				// 	this.fApi.setValue('invoicecompany',invoicecompany)
				// }
				
				
			}
		},
		components: {

		}
	}
</script>
